import { render, staticRenderFns } from "./catalogEdit.vue?vue&type=template&id=5fae4991&scoped=true&"
import script from "./catalogEdit.vue?vue&type=script&lang=js&"
export * from "./catalogEdit.vue?vue&type=script&lang=js&"
import style0 from "./catalogEdit.vue?vue&type=style&index=0&id=5fae4991&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fae4991",
  null
  
)

export default component.exports